import React from "react"
import trcss from "../../../styles/Telerecovery.module.css"
import { Tooltip } from "primereact/tooltip"
import { formatDate, getTimeAgo, transformMessage } from "../Utils"

export default function ChatMessage({ messages, fromName, fromInitials }) {

  const buildStaffMessage = () => {
    return (
      <div style={{ marginBottom: "15px" }}>
        <div className={trcss.messageData}
          style={{
            justifyContent: "flex-end",
            marginBottom: "5px"
          }}
        >
          <span className={trcss.messageDataTime}>
            {getTimeAgo(messages[0].dateUpdated)}
          </span>
        </div>
        <div style={{ float: "right" }} className={trcss.chatMessageBody}>
          {
            messages.map(message => showMsgBody(message, trcss.myMessage))
          }
        </div>
      </div>
    )
  }

  const buildParticipantMessage = () => {
    return (
      <div style={{ marginBottom: "15px" }}>
        <div className={trcss.messageData}>
          <span className={trcss.userInitials}>{fromInitials}</span>
          <div style={{ alignSelf: "center" }}>
            <span>{fromName.full_name}</span>
            <span className={trcss.messageDataTime}>{getTimeAgo(messages[0].dateUpdated)}</span>
          </div>
        </div>
        <div style={{ marginLeft: "42px", float: "left" }} className={trcss.chatMessageBody}>
          {
            messages.map(message => showMsgBody(message, trcss.participantMessage))
          }
        </div>
      </div>
    )
  }

  const showMsgBody = (message, classN) => {
    const dateClass = formatDate(message.dateUpdated, "MMMMdyyyyhmms")
    return (
      <div>
        <div
          className={classN + " " + dateClass}
        >
          {transformMessage(message)}
        </div>
        <Tooltip target={"." + dateClass} className="custom-tooltip" position="top">
          <span>
            {formatDate(message.dateUpdated, "MMMM d yyyy, h:mm:ss a")}
          </span>
        </Tooltip>
      </div>
    )
  }

  return (
    <>
      {messages[0].sentByParticipant === false
        ? buildStaffMessage()
        : buildParticipantMessage()}
    </>
  )
}